export const configurationTranslation = {
  title: 'configuration.pageTitle',
}

export const changeLanguageTranslation = {
  title: 'changeLanguage.title',
  select: {
    label: 'changeLanguage.select.label',
  },
  edit: {
    label: 'changeLanguage.edit.label',
  },
  save: {
    label: 'changeLanguage.save.label',
  },
}

export const passwordChangerTranslation = {
  title: 'passwordChanger.title',
  subtitle: 'passwordChanger.subtitle',
  currentPassword: {
    label: 'passwordChanger.currentPassword.label',
  },
  newPassword: {
    label: 'passwordChanger.newPassword.label',
    legend: 'passwordChanger.newPassword.legend',
  },
  repeatPassword: {
    label: 'passwordChanger.repeatPassword.label',
  },
  submit: 'passwordChanger.submit',
  success: 'passwordChanger.success',
}

export const userDataTranslation = {
  title: 'userData.title',
  name: {
    label: 'userData.name.label',
  },
  userName: {
    label: 'userData.username.label',
  },
  email: {
    label: 'userData.email.label',
  },
  edit: {
    label: 'userData.edit.label',
  },
  save: {
    label: 'userData.save.label',
  },
  success: 'userData.success',
}

export const deleteAccountTranslation = {
  title: 'deleteAccountTranslation.title',
  description: 'deleteAccountTranslation.description',
  deleteButton: 'deleteAccountTranslation.deleteButton',
  deletedSuccess: 'deleteAccountTranslation.deletedSuccess',
  modal: {
    title: 'deleteAccountTranslation.modal.title',
    description: 'deleteAccountTranslation.modal.description',
    reason: 'deleteAccountTranslation.modal.reason',
    reasonPlaceholder: 'deleteAccountTranslation.modal.reasonPlaceholder',
    acceptConditions: {
      label: 'deleteAccountTranslation.modal.acceptConditions.label',
      filename: 'deleteAccountTranslation.modal.acceptConditions.filename',
      link: 'deleteAccountTranslation.modal.acceptConditions.link',
      label2: 'deleteAccountTranslation.modal.acceptConditions.label2',
      error: 'deleteAccountTranslation.modal.acceptConditions.error',
    },
    successTitle: 'deleteAccountTranslation.modal.successTitle',
    successDescription: 'deleteAccountTranslation.modal.successDescription',
    successButton: 'deleteAccountTranslation.modal.successButton',
  },
}
